import {useDispatch} from 'react-redux';
import EventAnchorCardV4 from './EventAnchorCardV4';
import EventContentCardV4 from './EventContentCardV4';
import ModuleSectionV4 from './ModuleSectionV4';
import ContentCardWrapperV4 from '../../common/component/ContentCardWrapperV4';
import {Page} from '../../common/constant/page';
import {pToast} from '../../common/container/PToast';
import {showAuthModal} from '../../common/function';
import useLogin from '../../common/hook/useLogin';
import {routeTo} from '../../common/util/PageRouter';
import useEventPageEvent from '../hook/useEventPageEvent';
import {actions} from '../state/action';
import {
  IEventAnchorCardV4,
  IEventContentCardV4,
  IRecommendModuleV4,
} from '../type';

interface IProps {
  data: IRecommendModuleV4;
}

export default function RecommendModuleV4({data}: IProps) {
  const {section, divisionCount, recommendAnchorList, recommendContentList} =
    data;
  const {isLogin} = useLogin();
  const dispatch = useDispatch();
  const sendEventPageEvent = useEventPageEvent();

  const handleClickLike = (
    {id}: IEventAnchorCardV4,
    isLike: boolean,
    index: number
  ) => {
    sendEventPageEvent({
      actionName: 'content_favorite',
      customProps: {content_id: id},
    });
    if (isLogin) {
      dispatch(
        actions.fetchContentSubscribe({
          id,
          isOn: isLike,
          index,
        })
      );
    } else {
      showAuthModal({isSaveReturnPage: true});
    }
  };

  const handleClickKeyword = ({id}: IEventAnchorCardV4, keyword: string) => {
    sendEventPageEvent({
      actionName: 'keyword',
      customProps: {content_keyword: keyword, content_id: id},
    });
    if (isLogin) {
      routeTo({
        page: Page.ContentKeyword,
        keyword: encodeURIComponent(keyword),
      });
    } else {
      showAuthModal({isSaveReturnPage: true});
    }
  };

  const handleClickAnchor = ({id, sid, isBlockRouting}: IEventAnchorCardV4) => {
    sendEventPageEvent({
      actionName: 'content',
      customProps: {content_id: id},
    });
    if (!isLogin) {
      showAuthModal({isSaveReturnPage: true});
    } else if (isBlockRouting) {
      pToast(t => t('crm_recommend_not_sale'));
    } else {
      routeTo({page: Page.Content, id, sid});
    }
  };

  const handleClickContent = (_content: IEventContentCardV4) => {
    // TODO: V4 작품 클릭
  };

  return (
    <ModuleSectionV4 data-module-type={data.moduleType} section={section}>
      {!!recommendAnchorList && (
        <div className="flex flex-col gap-y-24">
          {recommendAnchorList.map((contentAnchor, index) => (
            <EventAnchorCardV4
              key={index}
              contentAnchor={contentAnchor}
              onClickLike={(content, isLike) =>
                handleClickLike(content, isLike, index)
              }
              onClickKeyword={handleClickKeyword}
              onClickAnchor={handleClickAnchor}
            />
          ))}
        </div>
      )}
      {!!recommendContentList && (
        <ContentCardWrapperV4 isBig={divisionCount === 2} isBigResponsive>
          {recommendContentList.map((content, index) => (
            <EventContentCardV4
              key={index}
              content={content}
              onClickContent={handleClickContent}
            />
          ))}
        </ContentCardWrapperV4>
      )}
    </ModuleSectionV4>
  );
}
